'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldLayout = function FieldLayout(_ref) {
  var id = _ref.id,
      className = _ref.className,
      label = _ref.label,
      type = _ref.type,
      description = _ref.description,
      required = _ref.required,
      errorMessages = _ref.errorMessages,
      warningMessages = _ref.warningMessages,
      children = _ref.children,
      inputId = _ref.inputId,
      maxErrors = _ref.maxErrors;

  var wrappingClass = 'input-field ' + type + ' ' + className;
  var divId = 'field-' + id;
  var errors = errorMessages.map(function (message) {
    return {
      message: message,
      errorClass: 'error-message'
    };
  }).concat(warningMessages.map(function (message) {
    return {
      message: message,
      errorClass: 'warning-message'
    };
  })).slice(0, maxErrors);

  return _react2.default.createElement(
    'div',
    { id: divId, className: wrappingClass },
    label && _react2.default.createElement(
      'label',
      { className: 'active', htmlFor: inputId },
      label,
      required ? _react2.default.createElement(
        'span',
        { className: 'required' },
        '*'
      ) : null
    ),
    children,
    errors.map(function (_ref2) {
      var message = _ref2.message,
          errorClass = _ref2.errorClass;
      return _react2.default.createElement(
        'div',
        { key: message, className: errorClass },
        message
      );
    }),
    description !== '' ? _react2.default.createElement(
      'div',
      { className: 'field-description' },
      description
    ) : null
  );
};

FieldLayout.displayName = 'FieldLayout';

FieldLayout.defaultProps = {
  className: '',
  label: '',
  description: '',
  errorMessages: [],
  warningMessages: [],
  required: false,
  maxErrors: 1
};

FieldLayout.propTypes = {
  id: _propTypes2.default.string.isRequired,
  required: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  label: _propTypes2.default.string,
  type: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  inputId: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node.isRequired,
  errorMessages: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])),
  warningMessages: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])),
  maxErrors: _propTypes2.default.number
};

exports.default = FieldLayout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/form/FieldLayout.js
// module id = 192
// module chunks = 0